import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardContent, TextField, Grid, CardActions, Button, InputAdornment, CircularProgress, MenuItem } from '@material-ui/core';
import { Switch, TextField as FormikTextField } from 'formik-material-ui';
import { Autocomplete } from '@material-ui/lab';
import { searchAADUsers, getAADUserFormDependencies, AADUserDependencies, addAADUser } from 'utils/SysUserUtils';
import { Formik, Field, Form } from 'formik';
import { useStyles, NotificationsSnackBar } from 'components/Shared/DynamicForm';
import SkeletonForm from 'components/Shared/SkeletonForm';
import { buildYupSchema } from 'utils/SchemaUtils';
import AADUserSchema from 'schemas/AADUser.schema.json';

const validation = buildYupSchema(AADUserSchema);

const AddAADUser = () => {
  const classes = useStyles();
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState('');
  const [fetching, setFetching] = useState(false);
  const [domains, setDomains] = useState(AADUserDependencies);
  const [domainsLoaded, setDomainsLoaded] = useState(false);

  useEffect(function retrieveDomains() {
    let mounted = true;
    const asyncEffect = async () => {
      const deps = await getAADUserFormDependencies(AADUserDependencies);
      mounted && setDomains(deps);
      mounted && setDomainsLoaded(true);
    };
    asyncEffect();
    return function cleanUP() {
      mounted = false;
    }
  }, [])

  useEffect(function handleSearch() {
    let mounted = true;
    const asyncEffect = async () => {
      if (search.length >= 3) {
        setFetching(true)
        const data = await searchAADUsers(search);
        mounted && setOptions(data);
        setFetching(false);
      } else {
        setOptions([]);
      };
    };
    asyncEffect();
    return function cleanUp() {
      mounted = false;
      setFetching(false);
    };
  }, [search])


  const handleSubmit = async (values, { setStatus, resetForm }) => {
    const editResult = await addAADUser(values);

    if (editResult.success) {
      setStatus({ success: true, message: "Form was submitted successfully", alertType: "success" });
      await new Promise(resolve => setTimeout(resolve, 5000));
      resetForm();
      setSearch('');
    } else {
      setStatus({ success: false, message: `There was an issue submitting the form. details: ${editResult.details && editResult.details.message}`, alertType: "error" });
      await new Promise(resolve => setTimeout(resolve, 5000));
    };
  };

  const SysUserDomains = React.useMemo(() => domains.find(r => r.name === "LuSystemRole"), [domains]);
  const UserGroupDomains = React.useMemo(() => domains.find(r => r.name === "UserGroup"), [domains]);

  return (
    <Grid container justify="center" style={{ padding: 16 }}>
      {domainsLoaded ? <Grid item xl={6} lg={6} md={10} sm={12}>
        <Card>
          <Formik
            initialValues={{
              name: '',
              id: '',
              title: '',
              assigntoprojects: false,
              isqcreviewer: false,
              sysrole: '',
              usergrp: '',
              inspid: ''
            }}
            onSubmit={handleSubmit}
            validationSchema={validation}
          >
            {props => (
              props.isSubmitting ?
                <Grid container justify="center"><CircularProgress /></Grid> :
                <Form className={classes.VerticalFormStyle} noValidate autoComplete="off">
                <CardHeader title="Add a User"></CardHeader>
                <Grid container justify="center">
                  <Grid item xs={12}>
                    <CardContent>
                      <Field
                        name="name"
                        component={Autocomplete}
                        options={options}
                        getOptionLabel={(option) => option.Name || ''}
                        getOptionSelected={(option, value) => option.Name === value.Name}
                        onInputChange={(event, value) => {
                          setSearch(value);
                        }}
                        onChange={(e, value) => {
                          value && props.setFieldValue("name", value.Name);
                          value && props.setFieldValue("title", value.Title);
                          value && props.setFieldValue("id", value.Id);
                          !value && props.setFieldValue("name", '');
                          !value && props.setFieldValue("title", '');
                          !value && props.setFieldValue("id", '');
                          !value && props.setFieldValue("assigntoprojects", false);
                          !value && props.setFieldValue("isqcreviewer", false);
                          !value && props.setFieldValue("sysrole", '');
                          !value && props.setFieldValue("usergrp", '');
                          !value && props.setFieldValue("inspid", '');
                        }}
                        renderInput={
                          (params) => (
                            <TextField
                              {...params}
                              label="Search for a resource"
                              variant="outlined"
                              error={props.touched.name && !options.find(r => r.Name === props.values.name)}
                              helperText={props.touched.name && !options.find(r => r.Name === props.values.name) ? "name is a required field" : null}
                              InputProps={fetching ? {
                                ...params.InputProps,
                                endAdornment: <InputAdornment position="end"><CircularProgress /></InputAdornment>
                              } : { ...params.InputProps }}
                            >
                            </TextField>
                          )
                        }
                      />
                      <br />
                      <Field
                        component={FormikTextField}
                        label="Title"
                        name="title"
                        variant="outlined"
                      />
                      <Field component={Switch} type="checkbox" name="assigntoprojects" />Assign to Projects?
                      <br />
                      <Field component={Switch} type="checkbox" name="isqcreviewer" />QC Reviewer?
                      <br />
                      <Field
                        component={FormikTextField}
                        select
                        label="Role"
                        name="sysrole"
                        variant="outlined"
                      >
                        {SysUserDomains.options.oneOf && SysUserDomains.options.oneOf.map(r => <MenuItem value={r.const} key={r.const}>{r.title}</MenuItem>)}
                      </Field>
                      <Field
                        component={FormikTextField}
                        select
                        label="User Group"
                        name="usergrp"
                        variant="outlined"
                      >
                        {UserGroupDomains.options.oneOf && UserGroupDomains.options.oneOf.map(r => <MenuItem value={r.const} key={r.const}>{r.title}</MenuItem>)}
                      </Field>
                      <Field
                        component={FormikTextField}
                        label="Inspector Number"
                        name="inspid"
                        variant="outlined"
                      />
                    </CardContent>
                    <CardActions style={{ padding: 16 }}>
                      <Button variant="contained" color="primary" type="submit">Add</Button>
                    </CardActions>
                  </Grid>
                </Grid>
                <NotificationsSnackBar status={props.status} setStatus={props.setStatus} refreshLagTime={3000}></NotificationsSnackBar>
              </Form>
            )}
          </Formik>
        </Card>

      </Grid>
        : <SkeletonForm />
      }
    </Grid >
  )
}

export default AddAADUser;